import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faTags } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import '../AdminCommon.css';
import './NewCategoria.css';

export default function NewCategoria({ onCategoriaCreated }) {
    const [categoria, setCategoria] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [cargando, setCargando] = useState(false);

    const toggleModal = () => {
        setCategoria('');
        setModalOpen(!modalOpen);
    };

    const crear = async (e) => {
        if (e) e.preventDefault();

        if (!categoria.trim()) {
            toast.warn('Por favor, ingresa el nombre de la categoría.');
            return;
        }

        const formData = new FormData();
        formData.append('categoria', categoria.trim());

        setCargando(true);
        try {
            const response = await fetch(`${baseURL}/categoriasPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                toggleModal();
                if (typeof onCategoriaCreated === 'function') {
                    onCategoriaCreated();
                } else {
                    window.location.reload();
                }
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al registrar categoría:', error);
            toast.error('Error de conexión. Inténtalo de nuevo.');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div>
            <button onClick={toggleModal} className="adminBtnPrimary" title="Agregar nueva categoría de platos o bebidas">
                <FontAwesomeIcon icon={faPlus} /> Agregar categoría
            </button>

            {modalOpen && (
                <div className="adminModalOverlay" onClick={toggleModal}>
                    <div className="adminModalContent modalSmallSimple" onClick={(e) => e.stopPropagation()}>
                        <div className="adminModalHeader">
                            <h3><FontAwesomeIcon icon={faTags} /> Agregar Categoría</h3>
                            <button type="button" className="adminModalClose" onClick={toggleModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <form onSubmit={crear}>
                            <div className="adminModalBody">
                                <div className="adminFormField">
                                    <label>Nombre de la Categoría (Obligatorio):</label>
                                    <input
                                        type="text"
                                        placeholder="Ej: Entradas, Carnes, Pastas, Bebidas..."
                                        value={categoria}
                                        onChange={(e) => setCategoria(e.target.value)}
                                        required
                                        autoFocus
                                    />
                                </div>
                            </div>
                            <div className="adminModalFooter">
                                <button type="button" className="adminBtnSecondary" onClick={toggleModal} disabled={cargando}>
                                    Cancelar
                                </button>
                                <button type="submit" className="adminBtnPrimary" disabled={cargando}>
                                    {cargando ? 'Guardando...' : 'Guardar Categoría'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
